/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRank3Filled = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-2.43-8.13c.273.147.59.263.95.35.36.08.703.12 1.03.12.473 0 .837-.097 1.09-.29.253-.193.38-.47.38-.83 0-.34-.1-.603-.3-.79-.193-.187-.48-.28-.86-.28a2.84 2.84 0 0 0-1.02.19l-.49-.82 1.8-1.9H9.7V8.35h4.43v1.03l-1.72 1.76c.647.073 1.143.3 1.49.68.353.373.53.843.53 1.41 0 .5-.113.933-.34 1.3a2.19 2.19 0 0 1-.98.83c-.42.193-.92.29-1.5.29-.38 0-.747-.04-1.1-.12a3.468 3.468 0 0 1-.94-.33v-1.33z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgRank3Filled as Rank3Filled };
